module.exports = __webpack_public_path__ + "media/images/icon__info--rb-gray@2x-48ff0e193b285f7b6e8d5fdd79b9db4e.png";